<template>
    <div class="case-list" >
        <div class="case-title">
            <img src="https://cdn.magicmart.vip/website/assets/case.png" alt="案例展示">
        </div>
        <div class="case-container">
            <div v-for="(item, index) in caseItems" :key="index" class="case-item" @click="goToCaseDetail(item)"
                @mouseenter="item.hovered = true" @mouseleave="item.hovered = false">
                <img :src="item.image" :alt="item.title">
                <div class="case-overlay" :class="{ 'overlay-visible': item.hovered }">
                    <h3 >{{ item.title }}</h3>
                    <div class="view-more-btn">查看更多</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CaseList',
    data() {
        return {
            caseItems: [
                {
                    image: 'https://cdn.magicmart.vip/website/assets/case/Aniya/2.png',
                    title: '间谍过家家杭州湖滨快闪店',
                    hovered: false,
                    id: 1
                },
                {
                    image: 'https://cdn.magicmart.vip/website/assets/case/hangzhoumodao/11.png',
                    title: '魔道祖师动画七周年杭州站',
                    hovered: false,
                    id: 2
                },
                {
                    image: 'https://cdn.magicmart.vip/website/assets/case/Jujutsu/1.png',
                    title: '上海静安大悦城 咒术回战',
                    hovered: false,
                    id: 3
                },
                {
                    image: 'https://cdn.magicmart.vip/website/assets/case/physicalStore/9.png',
                    title: '漫屋实体店现场场景照',
                    hovered: false,
                    id: 4
                },
                {
                    image: 'https://cdn.magicmart.vip/website/assets/case/shanghaimodao/15.png',
                    title: '魔道祖师动画七周年上海站',
                    hovered: false,
                    id: 5
                },
                {
                    image: 'https://cdn.magicmart.vip/website/assets/case/tianfumodao/16.png',
                    title: '魔道祖师动画七周年成都站',
                    hovered: false,
                    id: 6
                }
            ]
        }
    },
    methods: {
        goToCaseDetail(item) {
            this.$router.push(`/case-detail/${item.id}`)
        }
    }
}
</script>

<style scoped>
.case-list {
    width: 100%;
    background: #fff;
    padding-top: 145px;
}

.case-title {
    width: 193px;
    height: 95px;
    margin: 0 auto;
    margin-bottom: 106px;
}

.case-title img {
    width: 100%;
    height: 100%;
}

.case-container {
    width: 100%;
    max-width: 1600px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    padding: 0 20px;
}

.case-item {
    width: 491px;
    height: 275px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.case-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.case-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
}

.case-item:hover img {
    transform: scale(1.05);
}

.case-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.overlay-visible {
    opacity: 1;
}

.case-overlay h3 {
    font-weight: 600;
    font-size: 38px;
    color: #FFFFFF;
    margin-bottom: 14px;
    text-align: center;
}

.view-more-btn {
    color: #fff;
    font-size: 21px;
    cursor: pointer;
    transition: all 0.3s ease;
}

</style>
